/**
 * en-GB messages added by Phase 1 task S9 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s9EnGB = {};
//# sourceMappingURL=s9.js.map